import { render, staticRenderFns } from "./SocialResponsibility.vue?vue&type=template&id=448d4dbe&scoped=true&"
import script from "./SocialResponsibility.vue?vue&type=script&lang=js&"
export * from "./SocialResponsibility.vue?vue&type=script&lang=js&"
import style0 from "./SocialResponsibility.vue?vue&type=style&index=0&id=448d4dbe&prod&lang=scss&scoped=true&"
import style1 from "./SocialResponsibility.vue?vue&type=style&index=1&id=448d4dbe&prod&lang=scss&"
import style2 from "./SocialResponsibility.vue?vue&type=style&index=2&id=448d4dbe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d4dbe",
  null
  
)

export default component.exports